<template>
  <body>
    <div v-if="$route.meta.layout != 'simple'">
      <div class="d-flex flex-nowrap">
        <div class="collapse show" id="navbarToggleExternalContent" style="background-color: #f8f9fa; box-shadow: 1px 1px 5px 0px rgb(196 196 196)">
          <app-sidebar></app-sidebar>
        </div>
        <div id="mainClass" class="p-4">
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            style="top: 0; padding: 5px; border-radius: 5px; background-color: ghostwhite; border: 1px solid rebeccapurple; margin-left: -7px"
            data-bs-target="#navbarToggleExternalContent"
            aria-controls="navbarToggleExternalContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
            id="btntoggle-menu"
          >
            <i class="fas fa-bars"></i>
          </button>
          <div id="mainContainer" class="container">
            <router-view></router-view>
          </div>
          <app-footer></app-footer>
        </div>
      </div>
    </div>

    <div v-else class="container">
      <div class="d-flex justify-content-center mt-5">
        <router-view></router-view>
      </div>
    </div>
  </body>
</template>

<script>
import jQuery from "jquery";
import AppFooter from "./Shared/appFooter.vue";
const $ = jQuery;
window.$ = $;

export default {
  components: { AppFooter }, 
};

$(document).ready(() => {
  $(window).resize(function () {
    // if (window.matchMedia("(min-width: 767px)").matches) {
    //   $("#navbarToggleExternalContent").addClass("show");
    // } else {
    //   $("#navbarToggleExternalContent").removeClass("show");
    // }

    if (window.matchMedia("(min-width: 1640px)").matches) {
    $("#mainContainer").css("width","1645px");
  } 
  else{
    $("#mainContainer").css("width","1180px");
  }  

  if (window.matchMedia("(min-width: 1640px)").matches) {
    $("#mainClass").css("width","1582px");
  }
  else{
    $("#mainClass").css("width","auto");
  } 

  if (window.matchMedia("(min-width: 1640px)").matches) {
    $('.scrollarea').attr('style', 'width: 343px !important');
  }
  else{
    $('.scrollarea').attr('style', 'width: 280px !important');
  } 

  if (window.matchMedia("(min-width: 1640px)").matches) {   
    $('.sidebarScroll').attr('style', 'width: 343px !important');
  }
  else{
    $('.sidebarScroll').attr('style', 'width: 280px !important');
  } 


  });

  // if (window.matchMedia("(min-width: 767px)").matches) {
  //   $("#navbarToggleExternalContent").addClass("show");
  // } else {
  //   $("#navbarToggleExternalContent").removeClass("show");
  // }

  if (window.matchMedia("(min-width: 1640px)").matches) {
    $("#mainContainer").css("width","1645px");
  }  

  if (window.matchMedia("(min-width: 1640px)").matches) {
    $("#mainClass").css("width","1582px");
  }

  if (window.matchMedia("(min-width: 1640px)").matches) {
    $(".scrollarea").css("width","343px");
  }

  if (window.matchMedia("(min-width: 1640px)").matches) {   
    $('.sidebarScroll').attr('style', 'width: 343px !important');
  }


});
</script>

<style scoped>
.navbar-toggler:hover {
  border: 2px solid rebeccapurple !important;
}

</style>
